import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-continue */

/* eslint-disable no-case-declarations */
import { call, put, select, cancelled, cancel, race, take } from 'redux-saga/effects';
import loadingActions from '../actions/loading';
import errorActions from '../actions/error';
import get from '../utils/get';
import { anonymizeObject } from '../utils/tools';
import suggestionsViaBackend from './suggestionsViaBackend';
import { CRUD_FAILURE, DELETE, _SUCCESS, _LOADING, restActions, REVERSE_ADDRESS, SEARCH_ADDRESS, SUGGEST_SEARCH, EXPIRED_JWT, SUGGEST_SEARCH_VIA_BACKEND, BAD_ENCRYPTION_KEY, CLEAR_SESSION, ANNOUNCEMENT, FRONT_PATIENT_ADDRESS_SERVER, FRONT_PRO_ADDRESS_SERVER } from '../actions/constants';
import { SERIAL_CRUD_LOADING, SERIAL_CRUD_SUCCESS, SERIAL_CRUD_ERROR, SERIAL_CRUD_BREAK, SERIAL_CRUD_CONTINUE } from '../actions/serial';

var createType = function createType(type, suffixAction) {
  var _type$split = type.split('/'),
      _type$split2 = _slicedToArray(_type$split, 2),
      originalType = _type$split2[0],
      suffixOriginalType = _type$split2[1];

  return "".concat(originalType).concat(suffixAction).concat(suffixOriginalType ? "/".concat(suffixOriginalType) : '');
};

var noop = function noop() {};

var defaultTransformer = {
  in: function _in(data) {
    return data;
  },
  out: function out(data) {
    return data;
  }
};
export function crudActions(rest, options, action) {
  var throwError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _options$callbackErro, callbackError, _options$headerCallba, headerCallback, _options$transformerF, transformerFn, _options$extendAction, extendAction, transformer, abortController, _action$onSuccess, onSuccess, _action$onError, onError, _action$updateStore, updateStore, scope, resource, type, store, isDemoAccount, token, needRefreshToken, refresh, aesFileEncryptionKey, ivFileEncryptionKey, encryption, publicKey, response, actionOut, addressServerUrl, _addressServerSetting, addressSettings, _response2, dataResponse, headers, data, newAction, nextActions, i, nextActionFunction, _state, _yield$race2, actionSuccess, _store, _data, _newAction;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _options$callbackErro = options.callbackError, callbackError = _options$callbackErro === void 0 ? noop : _options$callbackErro, _options$headerCallba = options.headerCallback, headerCallback = _options$headerCallba === void 0 ? noop : _options$headerCallba, _options$transformerF = options.transformerFn, transformerFn = _options$transformerF === void 0 ? defaultTransformer : _options$transformerF, _options$extendAction = options.extendAction, extendAction = _options$extendAction === void 0 ? function (_action) {
            return _action;
          } : _options$extendAction;
          _context.next = 3;
          return transformerFn;

        case 3:
          transformer = _context.sent;
          abortController = new AbortController();
          _action$onSuccess = action.onSuccess, onSuccess = _action$onSuccess === void 0 ? noop : _action$onSuccess, _action$onError = action.onError, onError = _action$onError === void 0 ? noop : _action$onError, _action$updateStore = action.updateStore, updateStore = _action$updateStore === void 0 ? true : _action$updateStore, scope = action.scope, resource = action.resource, type = action.type;
          _context.prev = 6;
          _context.next = 9;
          return select(function (s) {
            return s;
          });

        case 9:
          store = _context.sent;
          _context.next = 12;
          return select(function (state) {
            var _state$authentication, _state$users;

            return (state === null || state === void 0 || (_state$authentication = state.authentication) === null || _state$authentication === void 0 || (_state$authentication = _state$authentication.item) === null || _state$authentication === void 0 || (_state$authentication = _state$authentication.userPatientInformation) === null || _state$authentication === void 0 ? void 0 : _state$authentication.isDemo) || ( // frontend (pat & pro)
            state === null || state === void 0 || (_state$users = state.users) === null || _state$users === void 0 || (_state$users = _state$users.item) === null || _state$users === void 0 || (_state$users = _state$users.userPatientInformation) === null || _state$users === void 0 ? void 0 : _state$users.isDemo);
          } // mobile
          );

        case 12:
          isDemoAccount = _context.sent;

          if (!updateStore) {
            _context.next = 16;
            break;
          }

          _context.next = 16;
          return put(_objectSpread(_objectSpread({}, action), {}, {
            type: createType(type, _LOADING)
          }));

        case 16:
          _context.next = 18;
          return put(loadingActions.addLoading(action));

        case 18:
          if (!(isDemoAccount || scope !== 'pat-public')) {
            _context.next = 24;
            break;
          }

          _context.next = 21;
          return select(function (state) {
            return get(state, 'authentication.item.token') || // frontend (pat & pro)
            get(state, 'users.item.token') || // mobile
            get(action, 'payload.params.token') || (typeof localStorage !== 'undefined' ? localStorage.getItem('tokenPat') : null);
          });

        case 21:
          _context.t0 = _context.sent;
          _context.next = 25;
          break;

        case 24:
          _context.t0 = null;

        case 25:
          token = _context.t0;
          needRefreshToken = scope === 'auth' || "".concat(resource, "_").concat(action.type) === 'deleteUserRequests_CREATE';

          if (!needRefreshToken) {
            _context.next = 33;
            break;
          }

          _context.next = 30;
          return select(function (state) {
            return get(state, 'users.item.refresh') || // mobile
            get(state, 'authentication.item.refresh') || (typeof localStorage !== 'undefined' ? localStorage.getItem('refreshPat') : null);
          } // frontend (pat & pro)
          );

        case 30:
          _context.t1 = _context.sent;
          _context.next = 34;
          break;

        case 33:
          _context.t1 = null;

        case 34:
          refresh = _context.t1;
          _context.next = 37;
          return select(function (state) {
            return get(state, 'authentication.item.aesKey') || // frontend (pat & pro)
            get(state, 'users.item.aesKey');
          } // mobile
          );

        case 37:
          aesFileEncryptionKey = _context.sent;
          _context.next = 40;
          return select(function (state) {
            return get(state, 'authentication.item.iv') || get(state, 'users.item.iv');
          });

        case 40:
          ivFileEncryptionKey = _context.sent;
          _context.next = 43;
          return select(function (state) {
            return get(state, 'announcements.encryption', false);
          });

        case 43:
          encryption = _context.sent;
          _context.next = 46;
          return select(function (state) {
            return get(state, 'serverConfiguration.publicKey', null);
          });

        case 46:
          publicKey = _context.sent;
          actionOut = transformer.out(action, store);
          _context.t2 = type;
          _context.next = _context.t2 === SUGGEST_SEARCH ? 51 : _context.t2 === SEARCH_ADDRESS ? 55 : _context.t2 === REVERSE_ADDRESS ? 55 : 69;
          break;

        case 51:
          _context.next = 53;
          return call(rest.algoliaSearchActions, actionOut.payload.query, actionOut.payload.options);

        case 53:
          response = _context.sent;
          return _context.abrupt("break", 72);

        case 55:
          _context.next = 57;
          return select(function (state) {
            return get(state, 'announcements.addressServerUrl');
          });

        case 57:
          addressServerUrl = _context.sent;

          if (addressServerUrl) {
            _context.next = 65;
            break;
          }

          _context.next = 61;
          return fetch("".concat(rest.endpoints.api, "/").concat(scope, "/addressSettings")).then(function (res) {
            if (!res.ok) {
              return {};
            }

            return res.json();
          });

        case 61:
          addressSettings = _context.sent;
          addressServerUrl = (addressSettings === null || addressSettings === void 0 || (_addressServerSetting = addressSettings.addressServerSettingsList) === null || _addressServerSetting === void 0 || (_addressServerSetting = _addressServerSetting.find(function (setting) {
            return setting.enabled;
          })) === null || _addressServerSetting === void 0 ? void 0 : _addressServerSetting.url) || rest.endpoints.address; // store it for later use

          _context.next = 65;
          return put({
            type: ANNOUNCEMENT,
            payload: {
              service: scope === 'pat-public' ? FRONT_PATIENT_ADDRESS_SERVER : FRONT_PRO_ADDRESS_SERVER,
              channel: 'addressServerUrl',
              url: addressServerUrl
            }
          });

        case 65:
          _context.next = 67;
          return call(type === SEARCH_ADDRESS ? rest.addressActions : rest.reverseAddressActions, addressServerUrl, _objectSpread(_objectSpread({}, actionOut), {}, {
            signal: abortController.signal
          }));

        case 67:
          response = _context.sent;
          return _context.abrupt("break", 72);

        case 69:
          _context.next = 71;
          return call(rest.crudActions, _objectSpread(_objectSpread({}, actionOut), {}, {
            payload: _objectSpread(_objectSpread({}, actionOut.payload), {}, {
              token: token,
              refresh: refresh,
              encryption: encryption,
              publicKey: publicKey,
              aesFileEncryptionKey: aesFileEncryptionKey,
              ivFileEncryptionKey: ivFileEncryptionKey
            }),
            signal: abortController.signal
          }));

        case 71:
          response = _context.sent;

        case 72:
          _response2 = response, dataResponse = _response2.data, headers = _response2.headers;
          data = transformer.in(dataResponse, store);
          _context.next = 76;
          return headerCallback(headers);

        case 76:
          newAction = extendAction(_objectSpread(_objectSpread({}, action), {}, {
            type: createType(type, _SUCCESS),
            resource: action.resource,
            payload: action.type === DELETE ? _objectSpread(_objectSpread({}, data), action.payload) : data,
            query: _objectSpread({}, action.payload)
          }), store);

          if (!updateStore) {
            _context.next = 80;
            break;
          }

          _context.next = 80;
          return put(newAction);

        case 80:
          _context.next = 82;
          return put(loadingActions.removeLoading(action));

        case 82:
          onSuccess(data); // Is it outdated? We already has serialAction?

          nextActions = action.nextActions;

          if (!nextActions) {
            _context.next = 99;
            break;
          }

          i = 0;

        case 86:
          if (!(i < nextActions.length)) {
            _context.next = 99;
            break;
          }

          if (!(typeof nextActions[i] === 'function')) {
            _context.next = 94;
            break;
          }

          nextActionFunction = nextActions[i](data, action);

          if (!nextActionFunction) {
            _context.next = 92;
            break;
          }

          _context.next = 92;
          return put(nextActionFunction);

        case 92:
          _context.next = 96;
          break;

        case 94:
          _context.next = 96;
          return put(nextActions[i]);

        case 96:
          i++;
          _context.next = 86;
          break;

        case 99:
          return _context.abrupt("return", data);

        case 102:
          _context.prev = 102;
          _context.t3 = _context["catch"](6);

          if (process.env.DEBUG) {
            // eslint-disable-next-line no-console
            console.error(anonymizeObject(_context.t3, ['token', 'refresh', 'password']));
          }

          _context.next = 107;
          return select(function (s) {
            return s;
          });

        case 107:
          _state = _context.sent;
          // @ts-ignore
          callbackError(action, _context.t3, _state);
          _context.next = 111;
          return put(loadingActions.removeLoading(action));

        case 111:
          _context.next = 113;
          return put(errorActions.addError(action, _context.t3));

        case 113:
          if (!(_context.t3.code === EXPIRED_JWT || _context.t3.code === BAD_ENCRYPTION_KEY)) {
            _context.next = 116;
            break;
          }

          _context.next = 116;
          return put({
            type: CLEAR_SESSION,
            payload: {
              reason: _context.t3.code,
              action: action
            }
          });

        case 116:
          if (!updateStore) {
            _context.next = 119;
            break;
          }

          _context.next = 119;
          return put(extendAction({
            type: CRUD_FAILURE,
            resource: action.resource,
            payload: {
              action: action,
              timeStampRequest: +new Date()
            },
            error: _context.t3
          }, _state));

        case 119:
          if (![SEARCH_ADDRESS, REVERSE_ADDRESS].includes(action.type)) {
            _context.next = 139;
            break;
          }

          _context.next = 122;
          return put({
            type: "".concat(action.type, "_BACKUP"),
            payload: action.payload
          });

        case 122:
          _context.next = 124;
          return race({
            actionSuccess: take("".concat(action.type, "_BACKUP_SUCCESS")),
            actionFailed: take("".concat(action.type, "_BACKUP_FAILED"))
          });

        case 124:
          _yield$race2 = _context.sent;
          actionSuccess = _yield$race2.actionSuccess;

          if (!actionSuccess) {
            _context.next = 139;
            break;
          }

          _context.next = 129;
          return select(function (s) {
            return s;
          });

        case 129:
          _store = _context.sent;
          _data = actionSuccess.payload;
          _newAction = extendAction(_objectSpread(_objectSpread({}, action), {}, {
            type: createType(type, _SUCCESS),
            resource: action.resource,
            payload: action.type === DELETE ? _objectSpread(_objectSpread({}, _data), action.payload) : _data,
            query: _objectSpread({}, action.payload)
          }), _store);

          if (!updateStore) {
            _context.next = 135;
            break;
          }

          _context.next = 135;
          return put(_newAction);

        case 135:
          _context.next = 137;
          return put(loadingActions.removeLoading(action));

        case 137:
          onSuccess(_data);
          return _context.abrupt("return");

        case 139:
          onError(_context.t3);

          if (!throwError) {
            _context.next = 142;
            break;
          }

          throw _context.t3;

        case 142:
          return _context.abrupt("return");

        case 143:
          _context.prev = 143;
          _context.next = 146;
          return cancelled();

        case 146:
          if (!_context.sent) {
            _context.next = 148;
            break;
          }

          abortController.abort();

        case 148:
          return _context.finish(143);

        case 149:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 102, 143, 149]]);
  })();
}
export function serialCrudActions(rest) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var action = arguments.length > 2 ? arguments[2] : undefined;
  return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _action$payload, actions, _action$payload$throw, throwError, _options$callbackErro2, callbackError, _action$onError2, onError, _action$onSuccess2, onSuccess, baseAction, error, lastErrorAction, lastErrorIndex, prevData, i, serialAction, _serialAction, _serialAction2, _state2, stepAction, _serialAction4, type, _rest$endpoints, _state3;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload = action.payload, actions = _action$payload.actions, _action$payload$throw = _action$payload.throwError, throwError = _action$payload$throw === void 0 ? true : _action$payload$throw;
          _options$callbackErro2 = options.callbackError, callbackError = _options$callbackErro2 === void 0 ? noop : _options$callbackErro2;
          _action$onError2 = action.onError, onError = _action$onError2 === void 0 ? noop : _action$onError2, _action$onSuccess2 = action.onSuccess, onSuccess = _action$onSuccess2 === void 0 ? noop : _action$onSuccess2;
          baseAction = action;
          _context2.next = 6;
          return put({
            type: SERIAL_CRUD_LOADING
          });

        case 6:
          error = null;
          lastErrorAction = null;
          lastErrorIndex = -1;
          prevData = null;
          i = 0;

        case 11:
          if (!(i < actions.length)) {
            _context2.next = 66;
            break;
          }

          if (!(baseAction !== null && baseAction !== void 0 && baseAction.cancelled)) {
            _context2.next = 15;
            break;
          }

          error = new Error('Cancelled');
          return _context2.abrupt("break", 66);

        case 15:
          serialAction = void 0;
          _context2.prev = 16;
          _context2.next = 19;
          return select(function (s) {
            return s;
          });

        case 19:
          _state2 = _context2.sent;
          stepAction = actions[i](_state2, {
            prevData: prevData
          });
          prevData = null;

          if (stepAction) {
            _context2.next = 24;
            break;
          }

          return _context2.abrupt("continue", 63);

        case 24:
          serialAction = stepAction;

          if (!(stepAction instanceof Promise)) {
            _context2.next = 29;
            break;
          }

          _context2.next = 28;
          return stepAction;

        case 28:
          serialAction = _context2.sent;

        case 29:
          if (!(!serialAction || (_serialAction = serialAction) !== null && _serialAction !== void 0 && _serialAction._thisIsNotAction || !((_serialAction2 = serialAction) !== null && _serialAction2 !== void 0 && _serialAction2.type))) {
            _context2.next = 32;
            break;
          }

          prevData = serialAction;
          return _context2.abrupt("continue", 63);

        case 32:
          _serialAction4 = serialAction, type = _serialAction4.type;

          if (!(type === SERIAL_CRUD_BREAK)) {
            _context2.next = 37;
            break;
          }

          _context2.next = 36;
          return put(serialAction);

        case 36:
          return _context2.abrupt("break", 66);

        case 37:
          if (!(type === SERIAL_CRUD_CONTINUE)) {
            _context2.next = 41;
            break;
          }

          _context2.next = 40;
          return put(serialAction);

        case 40:
          return _context2.abrupt("continue", 63);

        case 41:
          if (!(restActions.indexOf(serialAction.type.replace("/".concat(serialAction.resource), '')) >= 0)) {
            _context2.next = 47;
            break;
          }

          _context2.next = 44;
          return call(crudActions, rest, options, serialAction, throwError);

        case 44:
          prevData = _context2.sent;
          _context2.next = 55;
          break;

        case 47:
          if (!(serialAction.type === SUGGEST_SEARCH_VIA_BACKEND)) {
            _context2.next = 53;
            break;
          }

          _context2.next = 50;
          return call(suggestionsViaBackend, rest === null || rest === void 0 || (_rest$endpoints = rest.endpoints) === null || _rest$endpoints === void 0 ? void 0 : _rest$endpoints.algolia, serialAction);

        case 50:
          prevData = _context2.sent;
          _context2.next = 55;
          break;

        case 53:
          _context2.next = 55;
          return put(_objectSpread({}, serialAction));

        case 55:
          _context2.next = 63;
          break;

        case 57:
          _context2.prev = 57;
          _context2.t0 = _context2["catch"](16);
          error = _context2.t0;
          lastErrorAction = serialAction;
          lastErrorIndex = i;
          return _context2.abrupt("break", 66);

        case 63:
          i++;
          _context2.next = 11;
          break;

        case 66:
          if (!error) {
            _context2.next = 80;
            break;
          }

          // eslint-disable-next-line no-console
          console.trace(error);
          _context2.next = 70;
          return put({
            type: SERIAL_CRUD_ERROR,
            payload: {
              error: String(error)
            }
          });

        case 70:
          if (lastErrorAction) callbackError(lastErrorAction, error);
          _context2.next = 73;
          return select(function (s) {
            return s;
          });

        case 73:
          _state3 = _context2.sent;
          onError({
            error: error,
            context: {
              index: lastErrorIndex,
              action: lastErrorAction,
              state: _state3,
              cancelled: baseAction.cancelled
            }
          });

          if (!baseAction.cancelled) {
            _context2.next = 78;
            break;
          }

          _context2.next = 78;
          return cancel();

        case 78:
          _context2.next = 83;
          break;

        case 80:
          _context2.next = 82;
          return put({
            type: SERIAL_CRUD_SUCCESS
          });

        case 82:
          onSuccess();

        case 83:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[16, 57]]);
  })();
}
//# sourceMappingURL=sagas.js.map